import {
  rescheduleHistoryTableAssociateColumnsBy,
  rescheduleHistoryTableAssociateColumnsTo,
  rescheduleHistoryTableClientColumns,
  rescheduleHistoryTableColumns,
} from '../../../constants/tableColumns';
import { useAuthContext } from '../../../contexts/AuthProvider';
import { useRescheduleHistoryContext } from '../../../contexts/RescheduleHistoryProvider';
import { User } from '../../../types/users';
import AcademiaLoading from '../../CommonComps/Loadings/AcademiaLoading';
import AcademiaTable from '../../CommonComps/Tables/AcademiaTable';
import PageHeader from '../../CommonComps/Titles/PageHeader';
import RescheduleHistoryFilterActions from './RescheduleHistoryFilterActions';

const ShowAllRescheduleHistory = () => {
  // integration of context hooks here
  const { currentUser, currentUserType } = useAuthContext();
  const {
    isRescheduleHistoryLoading,
    isRescheduleHistoryFetching,
    rescheduleHistoryList,
    rescheduleHistoryType,
  } = useRescheduleHistoryContext();

  // rendering show reschedule history section component here
  return (
    <>
      {isRescheduleHistoryLoading ? (
        <AcademiaLoading />
      ) : (
        <section>
          <PageHeader headerText='Reschedule History' />

          <AcademiaTable
            data={rescheduleHistoryList}
            columns={
              currentUserType === 'client'
                ? rescheduleHistoryTableClientColumns
                : (currentUser as User)?.role_name === 'Admin'
                ? rescheduleHistoryTableColumns
                : rescheduleHistoryType === 'to'
                ? rescheduleHistoryTableAssociateColumnsTo
                : rescheduleHistoryTableAssociateColumnsBy
            }
            tableToolbarComponent={
              (currentUser as User)?.role_name === 'Associate' ? (
                <RescheduleHistoryFilterActions />
              ) : undefined
            }
            isTableDataLoading={isRescheduleHistoryFetching}
            notFoundMessage='No reschedule history found!'
          />
        </section>
      )}
    </>
  );
};

export default ShowAllRescheduleHistory;
